import { cssThemedValue } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

export const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  flex-grow: 1;
  flex-direction: column;
  gap: 8px;
  color: ${cssThemedValue('textPrimary')};
`;

const Description = styled(T.Body3)`
  color: ${cssThemedValue('textSecondary')};
`;

export const LoadingOverlay = () => {
  return (
    <Root>
      <Spinner size="extraLarge" style={{ marginBottom: '16px' }} />
      <T.Heading6>
        <FormattedMessage id="insights.loading.title" />
      </T.Heading6>
      <Description>
        <FormattedMessage id="insights.loading.description" />
      </Description>
    </Root>
  );
};
